var _dec, _dec2, _dec3, _class, _class2, _temp;
function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }
  return _assertThisInitialized(self);
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
import * as React from 'react';
import { Form } from '4finance-onion-form';
import { Map } from 'immutable';
import injectStyles from '4finance-components';
import translate from '4finance-translate';
import TryCountStorage from '../../services/TryCountStorage';
import RecoverType from '../../enums/recoverType';
import { Email, Phone, SubmitButton } from '../../fields';
import Reaptcha from 'reaptcha';
import styles from './RecoverBy.jss';
import { connectActions, connectState } from '../../redux/connect';
var RecoverBy = (_dec = connectActions({
  actions: ['passwordActions']
}), _dec2 = connectState({
  emailProps: ['passwordRecover', 'fieldsProps', 'email'],
  phoneProps: ['passwordRecover', 'fieldsProps', 'phone']
}), _dec3 = injectStyles(styles), _dec(_class = _dec2(_class = translate(_class = _dec3(_class = (_temp = _class2 = /*#__PURE__*/
function (_React$PureComponent) {
  _inherits(RecoverBy, _React$PureComponent);
  function RecoverBy(props) {
    var _this;
    _classCallCheck(this, RecoverBy);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(RecoverBy).call(this, props));
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "captcha", void 0);
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "_submitEmailRecover", function (e) {
      var checkRecoveryEmailValidity = _this.props.checkRecoveryEmailValidity;
      checkRecoveryEmailValidity(e.values.emailInput);
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "_submitPhoneRecover", function (e) {
      var checkRecoveryCodeValidity = _this.props.checkRecoveryCodeValidity;
      checkRecoveryCodeValidity(e.values.phoneInput);
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "_attemptCountExceeded", function () {
      var attemptCount = _this.props.attemptCount;
      var tryCount = TryCountStorage.getTryCount(); // First check for attempt count related to recipient
      // Second check for all attempts at all journeys

      return attemptCount >= 5 || tryCount !== null && tryCount.count >= 5;
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "_verifyCaptcha", function (response) {
      var setCaptchaToken = _this.props.actions.setCaptchaToken;
      _this.setState({
        isCaptchaValid: true
      }, function () {
        setCaptchaToken(response);
      });
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onInvisibleCaptchaRender", function () {
      return _this.captcha.execute();
    });
    _this.state = {
      isCaptchaValid: !(_this._attemptCountExceeded() || props.initiateWithCaptcha),
      captchaToken: ''
    };
    return _this;
  }
  _createClass(RecoverBy, [{
    key: "renderCaptcha",
    value: function renderCaptcha() {
      var _this2 = this;
      var _this$props = this.props,
        classes = _this$props.classes,
        captchaApiKey = _this$props.captchaApiKey,
        captchaLanguage = _this$props.captchaLanguage,
        initiateWithCaptcha = _this$props.initiateWithCaptcha,
        isCaptchaInvisible = _this$props.isCaptchaInvisible;
      if (initiateWithCaptcha || this._attemptCountExceeded()) {
        return isCaptchaInvisible ? React.createElement(Reaptcha, {
          className: classes.captcha,
          ref: function ref(e) {
            return _this2.captcha = e;
          },
          sitekey: captchaApiKey,
          onVerify: this._verifyCaptcha,
          size: "invisible",
          badge: "inline",
          hl: captchaLanguage,
          onRender: this.onInvisibleCaptchaRender
        }) : React.createElement("div", {
          className: classes.captcha
        }, React.createElement(Reaptcha, {
          sitekey: captchaApiKey,
          hl: captchaLanguage,
          onVerify: this._verifyCaptcha
        }));
      }
      return null;
    }
  }, {
    key: "renderEmailRecover",
    value: function renderEmailRecover() {
      var _this$props2 = this.props,
        classes = _this$props2.classes,
        msg = _this$props2.msg,
        emailProps = _this$props2.emailProps;
      var isCaptchaValid = this.state.isCaptchaValid;
      return React.createElement(Form, {
        name: "emailRecover",
        onSubmit: this._submitEmailRecover,
        resetOnMount: true
      }, React.createElement("div", {
        className: classes.formInnerWrapper
      }, React.createElement("h1", null, msg('recoverBy.emailTitle')), React.createElement("div", {
        className: classes.formControl
      }, React.createElement(Email, {
        name: "emailInput",
        fieldProps: emailProps.toJS(),
        bordered: true
      })), this.renderCaptcha(), React.createElement(SubmitButton, {
        disabled: !isCaptchaValid,
        type: "submit"
      }, msg('recoverBy.emailSubmitButtonText'))));
    }
  }, {
    key: "renderPhoneRecover",
    value: function renderPhoneRecover() {
      var _this$props3 = this.props,
        msg = _this$props3.msg,
        phoneProps = _this$props3.phoneProps,
        classes = _this$props3.classes,
        phoneNumberFormat = _this$props3.phoneNumberFormat;
      var isCaptchaValid = this.state.isCaptchaValid;
      return React.createElement(Form, {
        name: "phoneRecover",
        onSubmit: this._submitPhoneRecover,
        resetOnMount: true
      }, React.createElement("div", {
        className: classes.formInnerWrapper
      }, React.createElement("h1", null, msg('recoverBy.phoneTitle')), React.createElement("div", {
        className: classes.formControl
      }, React.createElement(Phone, {
        name: "phoneInput",
        regexp: phoneNumberFormat,
        fieldProps: phoneProps.toJS(),
        bordered: true
      })), this.renderCaptcha(), React.createElement(SubmitButton, {
        disabled: !isCaptchaValid,
        type: "submit"
      }, msg('recoverBy.phoneSubmitButtonText'))));
    }
  }, {
    key: "renderRecoverType",
    value: function renderRecoverType() {
      var recoverType = this.props.recoverType;
      switch (recoverType) {
        case RecoverType.EMAIL_RECOVER:
          return this.renderEmailRecover();
        case RecoverType.PHONE_RECOVER:
          return this.renderPhoneRecover();
      }
      return null;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
        classes = _this$props4.classes,
        children = _this$props4.children;
      return React.createElement("div", {
        className: classes.container
      }, this.renderRecoverType(), React.createElement("div", null, children));
    }
  }]);
  return RecoverBy;
}(React.PureComponent), _defineProperty(_class2, "styleRoot", 'RecoverBy'), _defineProperty(_class2, "defaultProps", {
  classes: {},
  msg: function msg() {
    return '';
  },
  emailProps: Map(),
  phoneProps: Map()
}), _temp)) || _class) || _class) || _class) || _class);
export { RecoverBy as default };